export default __webpack_public_path__ + "static/media/novedades_mascara.a814bde3.jpg";